module.exports = __webpack_public_path__ + "static/bg04-9941ddd6ad9b7172f5504bacc1f7027f.jpg";